import api from './api';

export const cctvService = {
  // Pobierz wszystkie rejestratory kamer (bez paginacji)
  getRecorders: async () => {
    const response = await api.get('/cctv/recorders');
    return response.data;
  },

  // Wykryj typ rejestratora
  detectDeviceType: async (deviceId) => {
    const response = await api.post(`/cctv/${deviceId}/detect`);
    return response.data;
  },

  // Pobierz listę kamer z rejestratora
  getCameras: async (deviceId, refresh = false) => {
    const response = await api.get(`/cctv/${deviceId}/cameras`, { params: { refresh } });
    return response.data;
  },

  // Pobierz URL strumienia dla kamery
  getStreamUrl: async (deviceId, cameraId, streamType = 'main') => {
    const response = await api.get(`/cctv/${deviceId}/stream/${cameraId}?type=${streamType}`);
    return response.data;
  }
};
